export class BuildingModel {
  heatingLocation: string;
  contactPersonName: string;
  contactPersonNumber: string;
  mainMeterReading: string;
  mainMeterReadingUnit: string;

  constructor() {
  }

  public static initialize(building: BuildingModel): void {
  }
}

